import { Button, InputCheckbox } from "@sellar-io/components";
import dayjs from "dayjs";
import { ProfilePicture } from "../../../../components";

import { DialogContent, DialogCTA } from "../../../../components/modal/Dialog";
import {
  TableLegacy,
  TableLegacyContainer,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTBody,
  TableLegacyTD,
} from "../../../../components/table/TableLegacy";
import type {
  SelectedSuppliersType,
  StepType,
} from "./PaymentMethodDeleteDialog";

export const PaymentMethodDeleteSupplierSelectionContent = ({
  selectedPaymentMethodIds,
  setSelectedPaymentMethodIds,
  suppliers,
  setStep,
}: {
  setSelectedPaymentMethodIds: (
    selectedPaymentMethodIds: number[] | undefined,
  ) => void;
  selectedPaymentMethodIds: number[] | undefined;
  suppliers: SelectedSuppliersType;
  setStep: (step: StepType) => void;
}) => {
  const allSuppliersSelected =
    selectedPaymentMethodIds?.length === suppliers.length;
  const itemIsChecked = (supplier: SelectedSuppliersType[number]) => {
    return !!selectedPaymentMethodIds?.find(
      (selectedPaymentMethodId) =>
        selectedPaymentMethodId === supplier.paymentMethodId,
    );
  };

  const allPaymentMethodIds = suppliers.map(
    (supplier) => supplier.paymentMethodId,
  );
  return (
    <>
      <DialogContent>
        <TableLegacyContainer className={"overflow-auto"}>
          <TableLegacy>
            <TableLegacyTHead>
              <TableLegacyTR>
                <TableLegacyTH>
                  <InputCheckbox
                    required={false}
                    checked={allSuppliersSelected}
                    onChange={() =>
                      setSelectedPaymentMethodIds(
                        allSuppliersSelected ? undefined : allPaymentMethodIds,
                      )
                    }
                  />
                </TableLegacyTH>
                <TableLegacyTH></TableLegacyTH>
                <TableLegacyTH>Supplier</TableLegacyTH>
                <TableLegacyTH>Last used</TableLegacyTH>
              </TableLegacyTR>
            </TableLegacyTHead>
            <TableLegacyTBody>
              {suppliers.map((supplier) => (
                <TableLegacyTR key={supplier.id} className={"cursor-pointer"}>
                  <TableLegacyTD className={"w-1/12"}>
                    <InputCheckbox
                      required={false}
                      checked={itemIsChecked(supplier)}
                      onChange={() => {
                        if (itemIsChecked(supplier)) {
                          return setSelectedPaymentMethodIds(
                            selectedPaymentMethodIds?.filter(
                              (paymentMethodId) =>
                                paymentMethodId !== supplier.paymentMethodId,
                            ),
                          );
                        }
                        setSelectedPaymentMethodIds([
                          ...(selectedPaymentMethodIds ?? []),
                          supplier.paymentMethodId,
                        ]);
                      }}
                    />
                  </TableLegacyTD>
                  <TableLegacyTD className={"w-1/12"}>
                    <ProfilePicture
                      name={supplier.name}
                      logoUrl={supplier.logoUrl}
                      size={"small"}
                    />
                  </TableLegacyTD>
                  <TableLegacyTD className={"w-5/12"}>
                    {supplier.name}
                  </TableLegacyTD>
                  <TableLegacyTD className={"w-5/12"}>
                    <p>
                      {dayjs(supplier.lastUsedAt).format("DD/MM/YYYY")} (
                      {dayjs(supplier.lastUsedAt).fromNow()})
                    </p>
                  </TableLegacyTD>
                </TableLegacyTR>
              ))}
            </TableLegacyTBody>
          </TableLegacy>
        </TableLegacyContainer>
      </DialogContent>
      <DialogCTA>
        <Button
          color={"red"}
          onClick={() => {
            if (!selectedPaymentMethodIds?.length) return;
            setStep("submit");
          }}
        >
          Remove
        </Button>
      </DialogCTA>
    </>
  );
};
